<template>
  <main id="profile-creation">
    <PageSceneLoader
      v-if="createProfileScene"
      :scene="createProfileScene"
      color="teal"
    />
  </main>
</template>

<script>
import PageSceneLoader from '@/components/loaders/PageSceneLoader';
import CreateProfileScene from './preloader';

export default {
  name: 'ProfileCreation',
  components: {
    PageSceneLoader,
  },
  data() {
    return {
      game: null,
    };
  },
  computed: {
    createProfileScene() {
      return this.game?.scene.scenes.find(s => s instanceof CreateProfileScene);
    },
  },
  created() {
    import('./init').then((gradeSelect) => {
      this.$nextTick(() => {
        this.game = gradeSelect.launch();
      });
    });
  },
};
</script>

<style lang="scss" scoped>
#profile-creation {
  display: flex;
  justify-content: center;
  height: 100vh;
}
</style>
